import { render, staticRenderFns } from "./UpgradeButton.vue?vue&type=template&id=233f350d&"
import script from "./UpgradeButton.vue?vue&type=script&lang=js&"
export * from "./UpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports